import { c as _c } from "react/compiler-runtime";
import GroupHeaderSelect from "./GroupHeaderSelect";
export default function GroupHeader() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-px-4 tw-pt-4"><GroupHeaderSelect /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}